import axios from "axios";
import { API_BASE_URL } from "../config";
import _ from "lodash";
import { BehaviorSubject, Observable } from 'rxjs'

let UtilsService = {};


UtilsService.constants = false;

UtilsService.getConstant = (hard = false) => {
    return new Promise(async (resolve, reject) => {

        if (UtilsService.constants && !hard) {
            return resolve(UtilsService.constants);
        } else {
            const url = `${API_BASE_URL}/admin/constants`;

            axios({ url }).then(
                (e) => {
                    if (_.get(e, "data.success", false)) {
                        UtilsService.constants = _.get(e, "data.data");
                        resolve(UtilsService.constants);
                    } else {
                        UtilsService.constants = false;
                        resolve(false);
                    }
                }, (er) => {
                    UtilsService.constants = false;
                    resolve(false);
                }
            );
        }
    });

}

UtilsService.processingSubject = new BehaviorSubject(false);
UtilsService.processing = UtilsService.processingSubject.asObservable();

UtilsService.changeProcessing = (status) => {
    if(UtilsService.processingSubject.getValue() !== status){
        UtilsService.processingSubject.next(status);
    }
}

/**
 * 
 * @param {string} url 
 * @param {Object} queryParams 
 * @returns 
 */
 UtilsService.addQueryParams = (url, queryParams) => {
    queryParams = _.map(queryParams, (value, key) => {
        return `${key}=${value}`;
    })
    queryParams = Object.values(queryParams).join("&")

    return `${url}?${queryParams}`;
}

UtilsService.dashboard = async (queryParams = {}) => {
    const url = UtilsService.addQueryParams(`${API_BASE_URL}/admin/dashboard`, queryParams);
    const res = await axios({ url });
    return res;
}

UtilsService.addMonthlyPremiumSingle = (plan) => {
    plan.monthly_fee = (plan.pricing && Array.isArray(plan.pricing)) ? plan.pricing.find(price => (price.billing_period === 'monthly')) : undefined;
    if (plan.monthly_fee) {
        plan.monthly_fee = plan.monthly_fee.amount;
    }
    return plan;
}



export default UtilsService;